/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum ReferenceTypeEnum {
    PAGE = 'PAGE',
    MENU = 'MENU',
}